<script setup lang="ts">
import EventCheckpointAutocomplete from '@/components/Filters/components/EventCheckpointAutocomplete.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import type { EventCheckpointType } from '@/types/filters/EventCheckpointType'
import type { EventModel } from '@/types/models/EventModel'
import { ref, watch } from 'vue'
import TypographyItem from '../../../../components/Typography/TypographyItem.vue'
import type { CheckpointModel } from '../../../../types/models/CheckpointModel'

type Props = {
    origin: EventCheckpointType
    destination: EventCheckpointType
}
const props = defineProps<Props>()

type Emits = {
    (
        e: 'change',
        { origin, destination }: { origin?: EventCheckpointType; destination?: EventCheckpointType }
    ): void
}
const emit = defineEmits<Emits>()

const originItem = ref<EventCheckpointType>({})
const destinationItem = ref<EventCheckpointType>({})
watch(
    () => props.origin,
    newOrigin => {
        originItem.value = { ...originItem.value, ...newOrigin }
    },
    { immediate: true, deep: true }
)
watch(
    () => props.destination,
    newDestination => (destinationItem.value = newDestination),
    { immediate: true, deep: true }
)

const handleChangeSite = (
    value: EventModel | undefined,
    selectedItem: EventCheckpointType,
    objectKey: string
) => {
    selectedItem.event = value
    selectedItem.checkpoint = undefined
    emit('change', { [objectKey]: selectedItem })
}
const handleChangePOI = (
    value: CheckpointModel | undefined,
    selectedItem: EventCheckpointType,
    objectKey: string
) => {
    selectedItem.checkpoint = value
    emit('change', { [objectKey]: selectedItem })
}
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <StackLayout :gap="8">
            <TypographyItem :label="$t('detection.filters.origin')" />
            <EventCheckpointAutocomplete
                :event="originItem.event"
                :checkpoint="originItem.checkpoint"
                @selectEvent="handleChangeSite($event, originItem, 'origin')"
                @selectCheckpoint="handleChangePOI($event, originItem, 'origin')" />
        </StackLayout>
        <StackLayout :gap="8">
            <TypographyItem :label="$t('detection.filters.destination')" />
            <EventCheckpointAutocomplete
                :event="destinationItem.event"
                :checkpoint="destinationItem.checkpoint"
                @selectEvent="handleChangeSite($event, destinationItem, 'destination')"
                @selectCheckpoint="handleChangePOI($event, destinationItem, 'destination')" />
        </StackLayout>
    </StackLayout>
</template>
